import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import OutsideClickHandler from 'ViatoUi/Shared/Utilities/OutsideClickHandler';

import styles from './Select.module.scss';

const Select = ({ options, value, label, required, onChange, className }) => {
	const [isOpen, setIsOpen] = useState(false);

	const valueOnlyOptionsList = [...options.map(option => option.value)];

	return (
		<OutsideClickHandler callback={() => setIsOpen(false)}>
			<div
				className={`${styles.select} ${className}`}
				data-active={isOpen}
				data-focused={valueOnlyOptionsList.includes(value)}
				data-required={required}
			>
				<div className={styles.label}>{label}</div>
				<div aria-hidden='true' className={styles.input} onClick={() => setIsOpen(!isOpen)}>
					{options.filter(option => option.value === value)[0]?.label}
				</div>
				<div className={styles.optionsList}>
					<Icon
						className={styles.icon}
						color='dark'
						icon='fa-angle-down'
						iconWeight='fas'
						size='l'
						onClick={() => setIsOpen(!isOpen)}
					/>
					<div className={styles.options} style={{ display: isOpen ? 'block' : 'none' }}>
						{options.map(option => (
							<div
								key={option.value}
								aria-hidden='true'
								className={styles.option}
								onClick={() => {
									setIsOpen(!isOpen);
									onChange(option);
								}}
							>
								{option.label}
							</div>
						))}
					</div>
				</div>
			</div>
		</OutsideClickHandler>
	);
};

Select.propTypes = {
	options: PropTypes.array.isRequired,
	value: PropTypes.string,
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	required: PropTypes.bool,
	onChange: PropTypes.func.isRequired
};

Select.defaultProps = {
	value: null,
	className: null,
	required: false
};

export default Select;
